export default __webpack_public_path__ + "static/media/music.d1ebe091.jpg";